import { Component, Input, OnInit } from '@angular/core';
import * as d3 from 'd3';

@Component({
  selector: 'app-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrls: ['./donut-chart.component.scss'],
})
export class DonutChartComponent implements OnInit {
  constructor() {}
  @Input() donutChartData: any;
  @Input() name!: string;
  @Input() width!: number;
  @Input() height!: number;
  @Input() strokeWidth!: string;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    const width = this.width,
      height = this.height,
      radius = Math.min(width, height) / 2;

    const pie: any = d3
      .pie()
      // .startAngle(Math.PI)
      // .endAngle(3.1 * Math.PI)
      .sort(null)
      .value(function (d: any) {
        return d.value;
      });

    const arc1: any = d3
      .arc()
      .innerRadius(radius - 30)
      .outerRadius(radius);

    const arc: any = d3
      .arc()
      .innerRadius(radius - 10)
      .outerRadius(radius - 10)
      .cornerRadius(10);

    const svg = d3
      .select(`#${this.name}`)
      .append('svg')
      .attr('width', '100%')
      .attr('height', '100%')
      .attr(
        'viewBox',
        -width / 2 + ' ' + -height / 2 + ' ' + width + ' ' + height
      )
      .append('g');
    svg
      .enter()
      .append('path')
      .attr('class', 'background')
      .attr('fill', '#71b06b')
      .attr('d', arc1);
    svg
      .selectAll('.foreground')
      .data(pie(this.donutChartData))
      .enter()
      .append('path')
      .attr('class', 'foreground')
      .attr('stroke-linejoin', 'round')
      .attr('stroke-linecap', 'round')
      .attr('stroke-width', this.strokeWidth || '15')
      .attr('stroke', 'none')
      .attr('stroke', function (d: any, i) {
        return d.data.color;
      })
      .attr('d', arc);
  }
}
